import React, { Fragment, useState, useRef } from "react";
import {
    Label,
    Button,
} from 'reactstrap';

import { Form, InputGroup, Modal } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { t } from 'i18next';
import FooterSignInPopup from "./FooterSignInPopup";
import TesTooltip from "../../Commons/TesTooltip";
import MineError from "../../Commons/MineError";
import { isValidPasswd } from "../../../helper/common";
import { toast } from "react-toastify";
import PasswordHandling from "../../../models/PasswordHandling";

export default function ResetPasswordPopup(props) {
    const { portalId, clientId } = props
    const [searchParams, setSearchParams] = useSearchParams();

    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setRetypeNewPassword] = useState('');
    const [showCode, setShowCode] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showPass2, setShowPass2] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const [hints, setHints] = useState([]);

    const [error, setError] = useState('')
    const [errorPasscode, setErrorPasscode] = useState('')

    const [disabledNext, setDisabledNext] = useState(true);

    // const dispatch = useDispatch();

    const onResetPassword = async (event) => {
        let username = searchParams.get("username")
        if (!username) {
            toast.error(`Please check your enter reset link for valid one`)
            return
        }
        const payload = {
            username,
            password: newPassword,
            code: code,
            portalId,
            clientId
        }
        console.log('payload: ', payload)

        try {
            // let result = await dispatch(CONFIRM_FORGOT_PASSWORD(payload))
            let result = await PasswordHandling.confirmPasswordResponse(payload)
            console.log('result', result)
            toast.success(`Successfully changing your password`)
            props.onNext()
        } catch (error) {
            setError(error.message || t('MsgErrorPasscodeInvalid'));
            return;
        }

    }

    const validate = async () => {
        let isValidPass = isValidPasswd(newPassword)
        let isMatchPass = (newPassword === newPassword2)
        let isValidCode = code && code.length >= 4

        for (let a of hintMsgs) {
            a.isValid = a.chk(newPassword)
        }
        setShowHint(true)
        setHints(hintMsgs)
        if (!isMatchPass && newPassword2) {
            setError('Not matched new password')
        } else if (!isValidCode) {
            setErrorPasscode('Passcode must be provided and at least 4 letters')
        } else {
            setError('')
            setErrorPasscode('')
        }
        setDisabledNext(!isValidPass || !isMatchPass || !isValidCode)
    }
    // (?=.*[a-z])        // use positive look ahead to see if at least one lower case letter exists
    // (?=.*[A-Z])        // use positive look ahead to see if at least one upper case letter exists
    // (?=.*\d)           // use positive look ahead to see if at least one digit exists
    // (?=.*\W)           // use positive look ahead to see if at least one non-word character exists

    const hintMsgs = [
        {
            chk: (text) => { return (text && text.trim().length >= 8) },
            msg: '8 Characters'
        },
        {
            chk: (text) => { return (text && /(?=.*[A-Z])/.test(text)) },
            msg: '1 Uppercase letter'
        },
        {
            chk: (text) => { return (text && /(?=.*[a-z])/.test(text)) },
            msg: '1 Lowercase letter'
        },
        {
            chk: (text) => { return (text && /(?=.*\d)/.test(text)) },
            msg: '1 Digit'
        },
        {
            chk: (text) => { return (text && /(?=.*[\W\-\_])/.test(text)) },
            msg: '1 Special character'
        },
    ]

    const onShow = async () => {
        let { newPassword, newPassword2, message } = props
        setShowCode(false)
        setDisabledNext(true)
        setCode("")
        setNewPassword(newPassword || "")
        setRetypeNewPassword(newPassword2 || "")
        setShowPass(false)
        setShowPass2(false)
        setShowHint(false)
        setError(message || '')
        for (let a of hintMsgs) {
            a.isValid = false
        }
        setHints(hintMsgs)
        if (newPassword && newPassword2) {
            validate()
        }
    }

    return (
        <Fragment>
            <Modal
                backdrop="static"
                keyboard={false}
                centered={true}
                size="md"
                show={props.show} onHide={props.onHide}
                onShow={onShow}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="text-center">{t('TextResetPassword')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12 form-group'>
                            <Label>
                                <span className="required">{t('TxtVerificationCode')}</span>
                                <TesTooltip target="codeSuggests" title="Password Reset Code" autohide={false}>
                                    <div> Please check the passcode received by email </div>
                                </TesTooltip>
                            </Label>

                            <InputGroup>
                                <Form.Control
                                    type={showCode ? 'text' : 'password'}
                                    name="code"
                                    value={code}
                                    id="code"
                                    aria-describedby="code5"
                                    onChange={(event) => { setCode(event.target.value) }}
                                    placeholder={t('LabelPasscode')}
                                    className="cp-input-box"
                                    onKeyUp={validate}
                                />
                                <InputGroup.Text className="password-eye">
                                    <i onClick={() => { setShowCode(!showCode) }} className={showCode ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
                                </InputGroup.Text>
                            </InputGroup>

                            {(errorPasscode) ? <MineError message={errorPasscode}></MineError> : null}
                        </div>
                    </div>

                    <div style={{ borderBottom: '0.063rem solid #eee', margin: '0.938rem auto' }}></div>

                    <div className='row'>
                        <div className='col-12 form-group'>
                            <Label>
                                <span className="required">{t('TxtCreateNewPass')}</span>
                                <TesTooltip target="passSuggests" title="Password must" autohide={false}>
                                    <div>
                                        <ul>
                                            <li>
                                                Be at least 8 characters long </li>
                                            <li>
                                                Contain at least one uppercase letter </li>
                                            <li>
                                                Contain at least one lowercase letter </li>
                                            <li>
                                                Contain at least one special character </li>
                                            <li>
                                                Enter and confirm passwords match</li>
                                        </ul>
                                    </div>
                                </TesTooltip>
                            </Label>
                            <InputGroup>
                                <Form.Control
                                    type={showPass ? 'text' : 'password'}
                                    name="newPassword"
                                    value={newPassword}
                                    id="newPassword5"
                                    aria-describedby="newPassword55"
                                    onChange={(event) => { setNewPassword(event.target.value) }}
                                    placeholder={t('PhdEnterNewPassword')}
                                    className="cp-input-box"
                                    onKeyUp={validate}
                                />
                                <InputGroup.Text className="password-eye">
                                    <i onClick={() => { setShowPass(!showPass) }} className={showPass ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
                                </InputGroup.Text>
                            </InputGroup>

                            <Form.Text id="newPassword55" muted>
                                {hints.map((a) => (
                                    <>
                                        <span key={a.msg} className={`password-hint ${showHint && (a.isValid ? 'success' : 'error')}`}>
                                            {a.isValid ?
                                                <i className="fa fa-check" aria-hidden="true"></i> :
                                                <i className="fa fa-times" aria-hidden="true"></i>
                                            }
                                            &nbsp;
                                            {a.msg} </span>
                                    </>
                                ))}
                            </Form.Text>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 form-group'>
                            <InputGroup>
                                <Form.Control
                                    type={showPass2 ? 'text' : 'password'}
                                    name="newPassword"
                                    value={newPassword2}
                                    id="newPassword6"
                                    aria-describedby="newPassword66"
                                    onChange={(event) => { setRetypeNewPassword(event.target.value) }}
                                    placeholder={t('PhdConfirmNewPassword')}
                                    className="cp-input-box"
                                    onKeyUp={validate}
                                />
                                <InputGroup.Text className="password-eye">
                                    <i onClick={() => { setShowPass2(!showPass2) }} className={showPass2 ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
                                </InputGroup.Text>
                            </InputGroup>

                        </div>
                    </div>

                    {(error) ? <MineError message={error}></MineError> : null}

                    <div className='row mt-2'>
                        <div className='col-12 text-center'>
                            <Button color="primary" size="lg" className="btn-block" style={{ borderRadius: '0.313rem' }} onClick={(e) => onResetPassword(e)} disabled={disabledNext}>
                                {t('BtnChangePassword')}</Button>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <FooterSignInPopup></FooterSignInPopup>
                </Modal.Footer>

            </Modal>
        </Fragment>
    );
}